/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateRecordingEnvelopePayloadRecordingDupIsrcsInner } from './CreateRecordingEnvelopePayloadRecordingDupIsrcsInner';
import {
    CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerFromJSON,
    CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerFromJSONTyped,
    CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerToJSON,
} from './CreateRecordingEnvelopePayloadRecordingDupIsrcsInner';

/**
 * 
 * @export
 * @interface CreateRecordingEnvelopePayloadRecording
 */
export interface CreateRecordingEnvelopePayloadRecording {
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    recordingTitle: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    duration?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    live?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    yearRecorded?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    countryOfRecording?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    recordingVersion?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    isrcs?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    pNames?: Array<string>;
    /**
     * Where this recording was found. Stored as a single-element list, matching the read model.
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    source: CreateRecordingEnvelopePayloadRecordingSourceEnum;
    /**
     * The recording's id at `source`. Required unless `source` is `other`, and checked against that source's id shape.
     * @type {string}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    recordingId?: string;
    /**
     * Recordings ISRCs in `isrcs` are being reassigned from, one entry per source recording
     * @type {Array<CreateRecordingEnvelopePayloadRecordingDupIsrcsInner>}
     * @memberof CreateRecordingEnvelopePayloadRecording
     */
    dupIsrcs?: Array<CreateRecordingEnvelopePayloadRecordingDupIsrcsInner>;
}


/**
 * @export
 */
export const CreateRecordingEnvelopePayloadRecordingSourceEnum = {
    Discogs: 'discogs',
    Musicbrainz: 'musicbrainz',
    Spotify: 'spotify',
    Deezer: 'deezer',
    Ppl: 'ppl',
    Other: 'other'
} as const;
export type CreateRecordingEnvelopePayloadRecordingSourceEnum = typeof CreateRecordingEnvelopePayloadRecordingSourceEnum[keyof typeof CreateRecordingEnvelopePayloadRecordingSourceEnum];


/**
 * Check if a given object implements the CreateRecordingEnvelopePayloadRecording interface.
 */
export function instanceOfCreateRecordingEnvelopePayloadRecording(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "recordingTitle" in value;
    isInstance = isInstance && "source" in value;

    return isInstance;
}

export function CreateRecordingEnvelopePayloadRecordingFromJSON(json: any): CreateRecordingEnvelopePayloadRecording {
    return CreateRecordingEnvelopePayloadRecordingFromJSONTyped(json, false);
}

export function CreateRecordingEnvelopePayloadRecordingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRecordingEnvelopePayloadRecording {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'recordingTitle': json['recording_title'],
        'duration': !exists(json, 'duration') ? undefined : json['duration'],
        'live': !exists(json, 'live') ? undefined : json['live'],
        'yearRecorded': !exists(json, 'year_recorded') ? undefined : json['year_recorded'],
        'countryOfRecording': !exists(json, 'country_of_recording') ? undefined : json['country_of_recording'],
        'recordingVersion': !exists(json, 'recording_version') ? undefined : json['recording_version'],
        'isrcs': !exists(json, 'isrcs') ? undefined : json['isrcs'],
        'pNames': !exists(json, 'p_names') ? undefined : json['p_names'],
        'source': json['source'],
        'recordingId': !exists(json, 'recording_id') ? undefined : json['recording_id'],
        'dupIsrcs': !exists(json, 'dup_isrcs') ? undefined : ((json['dup_isrcs'] as Array<any>).map(CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerFromJSON)),
    };
}

export function CreateRecordingEnvelopePayloadRecordingToJSON(value?: CreateRecordingEnvelopePayloadRecording | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'recording_title': value.recordingTitle,
        'duration': value.duration,
        'live': value.live,
        'year_recorded': value.yearRecorded,
        'country_of_recording': value.countryOfRecording,
        'recording_version': value.recordingVersion,
        'isrcs': value.isrcs,
        'p_names': value.pNames,
        'source': value.source,
        'recording_id': value.recordingId,
        'dup_isrcs': value.dupIsrcs === undefined ? undefined : ((value.dupIsrcs as Array<any>).map(CreateRecordingEnvelopePayloadRecordingDupIsrcsInnerToJSON)),
    };
}

